// extracted by mini-css-extract-plugin
module.exports = {"button":"PromoBanner_button__1cJ_J"};